module.exports = __webpack_public_path__ + "static/media/Knipsel.4dafcfef.png";